import Sidebar from '../../components/Common/Sidebar';
import AiStudioFramework from '../../components/_pages/AiStudio/AiStudioTabs';

const AiStudio = () => {
  return (
    <>
      <Sidebar />
      <AiStudioFramework/>
    </>
  );
};

export default AiStudio;
